import one from '../assets/svg/projects/one.png'
import two from '../assets/svg/projects/two.png'
import three from '../assets/svg/projects/three.png'
import four from '../assets/svg/projects/four.png'
import five from '../assets/svg/projects/five.png'
import six from '../assets/svg/projects/six.png'
import seven from '../assets/svg/projects/seven.png'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Responsive Lawfirm Website',
        projectDesc: 'This is a functioning lawfirm website that was designed using UI/UX best practices',
        tags: ['HTML5', 'CSS3', 'JavaScript', 'Tailwind'],
        code: 'https://github.com/Petzonke/Lawfirm',
        demo: 'https://mukwevhoattorneys.co.za',
        image: one
    },
    {
        id: 2,
        projectName: 'Church Of Life',
        projectDesc: 'This project involves the development of a church website to showcase the church\'s gallery and weekly sermons. It also let visitors book appoitments and more..',
        tags: ['WordPress', 'PhotoShop' , 'Elementor'],
        code: '#',
        demo: 'https://churchoflife.co.za',
        image: six
    },
    {
        id: 3,
        projectName: 'MUSHE GROUP',
        projectDesc: 'Mushe Group, AI-Driven Business Solutions, Data Analytics, Machine Learning, Global Services, Punctual Delivery, Data & AI Services, Software Solutions, Financial Markets Solutions, Secure TechnologiesThis project involves the development of a Job posting website for applying and posting jobs around South Africa.',
        tags: [ 'JavaScript', 'HTML', 'CSS', 'PHP'],
        code: '#',
        demo: 'https://mushegroup.com/',
        image: seven
    },
    {
        id: 4,
        projectName: 'Modelling Agency',
        projectDesc: 'Incomplete website for a modelling agency to post Events, Blogs, Media',
        tags: ['SCSS', 'Vanilla JS'],
        code: 'https://github.com/Petzonke/job-entry',
        demo: 'https://lelosmodelling.netlify.app',
        image: five
    },
    {
        id: 5,
        projectName: 'Landing Page',
        projectDesc: 'Responsive landing page UI/UX design for a food app',
        tags: ['React JS', 'Material UI'],
        code: 'https://github.com/Petzonke/landing-page',
        demo: 'https://foodie011.netlify.app',
        image: two
    },
    {
        id: 6,
        projectName: 'Job Portal',
        projectDesc: 'A responsive site for a modellingThis project involves the development of a Job posting website for applying and posting jobs around South Africa. agency',
        tags: ['JavaScript', 'HTML', 'CSS', 'PHP'],
        code: 'https://github.com/Petzonke/job-entry',
        demo: 'https://job-entry.netlify.app',
        image: four
    },
    {
        id: 7,
        projectName: 'Tesla clone',
        projectDesc: 'Tesla Website landing page clone',
        tags: ['HTML5', 'CSS3', 'JavaScript'],
        code: 'https://github.com/Petzonke/tesla-main-page-clone',
        demo: 'https://tesla-landing-page011.netlify.app',
        image: three
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/